import { Theme } from "@mui/material";
import { TYPE_LEAVE } from "modules/DeclareLeave/redux/getReasonLeave";

export const dayOfWeekMap = {
  0: "Chủ Nhật",
  1: "Thứ 2",
  2: "Thứ 3",
  3: "Thứ 4",
  4: "Thứ 5",
  5: "Thứ 6",
  6: "Thứ 7",
};

export const dayOfWeekMapCustom = {
  0: "CN",
  1: "T2",
  2: "T3",
  3: "T4",
  4: "T5",
  5: "T6",
  6: "T7",
};

export const DayTypeValue = {
  UNPAID_LEAVE: "unpaidLeave",
  SICK: "SICK",
  P: "P",
  LACK_OF_TIME_CHECKING: "lackOfTimeChecking",
  TIME_CHECKING: "timeChecking",
  DAY_LEAVE: "dayLeave",
  NO_DATA: "noData",
};

export type DayType =
  | "HALF_DAY"
  | "holiday"
  | "none"
  | "timeChecking"
  | "lackOfTimeChecking"
  | "birthday"
  | "unpaidLeave"
  | "SICK"
  | "DAY"
  | "P";

export const ApproveStatusValue = {
  PENDING: "PENDING",
  APPROVE: "APPROVE",
  REFUSE: "REFUSE",
  OVERTIME: "OVERTIME",
  AUTO_APPROVE: "AUTO_APPROVE",
  AUTO_REFUSE: "AUTO_REFUSE",
  CONFIRMED: "CONFIRMED",
  CANCEL: "CANCEL",
};

export const ApproveStatus = {
  PENDING: "Chờ duyệt",
  APPROVE: "Đã duyệt",
  REFUSE: "Từ chối",
  OVERTIME: "Hết hạn",
  AUTO_APPROVE: "Tự động duyệt",
  AUTO_REFUSE: "Tự động từ chối",
  CONFIRMED: "Đã xác nhận",
  CANCEL: "Đã hủy",
};

export type IApproveStatus = keyof typeof ApproveStatus;

export type TypeCSS = "border" | "background" | "color" | "iconColor";

export const dayTypeMap = {
  "HALF-DAY": "Nghỉ nửa ngày",
  HOLIDAY: "Nghỉ lễ",
  BIRTHDAY: "Nghỉ sinh nhật",
  unpaidLeave: "Nghỉ không lương",
  SICK: "Nghỉ ốm",
  P: "Nghỉ phép",
};

export const statusColor = (
  theme: Theme,
  status: IApproveStatus,
  typeCss: TypeCSS
) => {
  let statusColor = null;
  switch (status) {
    case ApproveStatusValue.APPROVE:
      statusColor = {
        iconColor: theme.palette.icon.icPositive,
        color: theme.palette.text.textPositive,
        border: theme.palette.icon.icPositive,
        background: theme.palette.background.bgPositiveSecondary,
      };
      break;
    case ApproveStatusValue.REFUSE:
      statusColor = {
        iconColor: theme.palette.icon.icNegative,
        color: theme.palette.text.textNegative,
        border: theme.palette.icon.icNegative,
        background: theme.palette.background.bgNegativePrimary,
      };
      break;
    case ApproveStatusValue.PENDING:
      statusColor = {
        iconColor: theme.palette.icon.icBrand,
        color: theme.palette.text.textLink,
        border: theme.palette.icon.icBrand,
        background: theme.palette.background.bgBrandPrimary,
      };
      break;
    case ApproveStatusValue.CONFIRMED:
      statusColor = {
        iconColor: theme.palette.icon.icBrand,
        color: theme.palette.text.textLink,
        border: theme.palette.icon.icBrand,
        background: theme.palette.background.bgBrandPrimary,
      };
      break;
    case ApproveStatusValue.AUTO_APPROVE:
      statusColor = {
        iconColor: theme.palette.icon.icPositive,
        color: theme.palette.text.textPositive,
        border: theme.palette.icon.icPositive,
        background: theme.palette.background.bgPositiveSecondary,
      };
      break;
    case ApproveStatusValue.AUTO_REFUSE:
    case ApproveStatusValue.CANCEL:
      statusColor = {
        iconColor: theme.palette.icon.icNegative,
        color: theme.palette.text.textNegative,
        border: theme.palette.icon.icNegative,
        background: theme.palette.background.bgNegativePrimary,
      };
      break;

    default:
      statusColor = {
        iconColor: theme.palette.icon.icBrand,
        color: theme.palette.text.textLink,
        border: theme.palette.icon.icBrand,
        background: theme.palette.background.bgBrandPrimary,
      };
      break;
  }
  return statusColor?.[typeCss];
};
export const dayColor = (theme: Theme, dayType: DayType, typeCss: TypeCSS) => {
  if (typeCss === "color") {
    switch (dayType) {
      case TYPE_LEAVE.HALF_DAY:
        return theme.palette.text.textPrimary;
    }
  }
  if (typeCss === "border") {
    switch (dayType) {
      case TYPE_LEAVE.HALF_DAY:
        return theme.palette.colorsBase.gray_3;
      case "holiday":
        return theme.palette.colorsBase.violet_0;
      case "timeChecking":
        return theme.palette.colorsBase.blue_0;
      case "lackOfTimeChecking":
        return theme.palette.colorsBase.orange_4;
      case "birthday":
        return theme.palette.colorsBase.green_0;
      case "unpaidLeave":
        return theme.palette.colorsBase.red_0;
      case "SICK":
        return theme.palette.colorsBase.orange_0;
      case "P":
        return theme.palette.colorsBase.green_0;
      default:
        return theme.palette.background.bgPrimary;
    }
  }
  if (typeCss === "background") {
    switch (dayType) {
      case TYPE_LEAVE.HALF_DAY:
        return theme.palette.colorsBase.gray_opacity_0_5;
      case "holiday":
        return theme.palette.colorsBase.violet_9;
      case "timeChecking":
        return theme.palette.colorsBase.blue_10;
      case "lackOfTimeChecking":
        return theme.palette.colorsBase.orange_9;
      case "birthday":
        return theme.palette.colorsBase.green_9;
      case "unpaidLeave":
        return theme.palette.colorsBase.red_9;
      case "SICK":
        return theme.palette.colorsBase.orange_9;
      case "P":
        return theme.palette.colorsBase.green_9;
      default:
        return theme.palette.background.bgPrimary;
    }
  }
};

export enum LeaveTypeBar {
  PAID_LEAVE = "PAID_LEAVE",
  UNPAID_LEAVE = "UNPAID_LEAVE",
  UNPAID_LEAVE_BENEFITS = "UNPAID_LEAVE_BENEFITS",
}

export const LeaveType = {
  LONG_TERM: "LONG_TERM",
  SHORT_TERM: "SHORT_TERM",
};

export const leaveTypeBar = {
  PAID_LEAVE: "#0EA374",
  UNPAID_LEAVE: "#EB2F2F",
  UNPAID_LEAVE_BENEFITS: "#D46B08",
};

export const optionTypeLeave = {
  [TYPE_LEAVE.FULL_DAY]: {
    label: "Nghỉ cả ngày",
    value: TYPE_LEAVE.FULL_DAY,
  },
  [TYPE_LEAVE.HALF_DAY]: {
    label: "Nghỉ nửa ngày",
    value: TYPE_LEAVE.HALF_DAY,
  },
};

export enum TYPE_REQ {
  ARRIVING_LATE = "LATE",
  LEAVE_EARLY = "EARLY",
}

export const optionTypeArrivingLate = {
  [TYPE_REQ.ARRIVING_LATE]: {
    label: "Đi muộn",
    value: TYPE_REQ.ARRIVING_LATE,
  },
  [TYPE_REQ.LEAVE_EARLY]: {
    label: "Về sớm",
    value: TYPE_REQ.LEAVE_EARLY,
  },
};

export const timeReq = [
  { value: "15", label: "15 phút" },
  { value: "30", label: "30 phút" },
  { value: "45", label: "45 phút" },
  { value: "60", label: "60 phút" },
  { value: "90", label: "90 phút" },
  { value: "120", label: "120 phút" },
];

export const typeReasonColor = [
  "#D46B08",
  "#182BCF",
  "#0EA374",
  "#B424C6",
  "#EB2F2F",
  "#B3B3B3",
];

export const trimData = (data) => {
  // If the data is a string, return the trimmed version.
  if (typeof data === "string") {
    return data.trim();
  }

  // If the data is an array, recursively trim each element.
  if (Array.isArray(data)) {
    return data.map((item) => trimData(item));
  }

  // If the data is a non-null object, iterate through its keys.
  if (data !== null && typeof data === "object") {
    return Object.keys(data).reduce((acc, key) => {
      acc[key] = trimData(data[key]);
      return acc;
    }, {});
  }

  // For all other types (number, boolean, null, undefined, etc.), return as-is.
  return data;
};

export const listApprover = [
  "leaderCode",
  "directorCode",
  "hrDirectorCode",
  "ceoCode",
  "codCode",
];

export enum STATUS_CONFIRM {
  WAITING_REQUEST = "WAITING_REQUEST",
  PENDING = "PENDING",
  CONFIRMED = "CONFIRMED",
  REFUSED = "REFUSED",
  AUTO_REFUSED = "AUTO_REFUSED",
  AUTO_CONFIRMED = "AUTO_CONFIRMED",
  APPROVE = "APPROVE",
  AUTO_APPROVE = "AUTO_APPROVE",
}

export const statusConfirmOption = {
  [STATUS_CONFIRM.WAITING_REQUEST]: {
    label: "Chờ gửi...",
  },
  [STATUS_CONFIRM.PENDING]: {
    label: "Chờ xác nhận",
  },
  [STATUS_CONFIRM.CONFIRMED]: {
    label: "Đã xác nhận",
  },
  [STATUS_CONFIRM.REFUSED]: {
    label: "Từ chối ",
  },
  [STATUS_CONFIRM.AUTO_REFUSED]: {
    label: "Tự động từ chối",
  },
  [STATUS_CONFIRM.AUTO_CONFIRMED]: {
    label: "Tự động xác nhận",
  },
  [STATUS_CONFIRM.AUTO_APPROVE]: {
    label: "Tự động xác nhận",
  },
  [STATUS_CONFIRM.APPROVE]: {
    label: "Đã xác nhận",
  },
};

export const getColorStatus = (status: STATUS_CONFIRM, theme: Theme) => {
  switch (status) {
    case STATUS_CONFIRM.WAITING_REQUEST:
      return theme.palette.colorsBase.orange_0;
    case STATUS_CONFIRM.PENDING:
      return theme.palette.colorsBase.blue_0; // blue
    case STATUS_CONFIRM.CONFIRMED:
    case STATUS_CONFIRM.REFUSED:
    case STATUS_CONFIRM.AUTO_REFUSED:
      return theme.palette.colorsBase.red_0; // red
    case STATUS_CONFIRM.AUTO_REFUSED:
    case STATUS_CONFIRM.AUTO_CONFIRMED:
    case STATUS_CONFIRM.AUTO_APPROVE:
    case STATUS_CONFIRM.APPROVE:
      return theme.palette.colorsBase.green_0;
    default:
      return theme.palette.colorsBase.gray_1; // gray
  }
};

export const TitleContent = {
  totalLeave: "Tổng số ngày nghỉ",
  totalLackOfTime: "Tổng số lần đi muộn/về sớm",
  leaveReason: "Lý do nghỉ",
  refuseReason: "Lý do từ chối",
  workAmount: "Công làm việc",
  reason: "Lý do giải trình",
  relatedPerson: "Người liên quan",
  approval: "Người phê duyệt",
  status: "Trạng thái",
  approvalDate: "Ngày phê duyệt",
  feedbackDate: "Ngày phản hồi",
  createDate: "Ngày tạo đơn",
  employeeName: "Người tạo đơn",
  note: "Lý do chi tiết",
  approveReason: "Lý do phê duyệt",
};
